import { defineApi, useProjectSpecificApiClient } from '../apiForm/api';

const useApi = defineApi({
  uploadFile: async (client, { file }) => {
    const formData = new FormData();
    formData.append('file', file);
    const { headers } = await client.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return (headers?.location || '') as string;
  },
});

export default function useFrontendResourcesApi() {
  const client = useProjectSpecificApiClient({
    basePath: '/frontend-resources',
  });
  return useApi(client);
}
